var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6385 2.10648C11.8882 2.0975 12.1305 2.19278 12.3072 2.3695L21.6305 11.6928C21.8072 11.8695 21.9025 12.1117 21.8935 12.3615C21.8004 14.952 20.7114 17.2893 19.0003 19.0003C17.2098 20.7909 14.7335 21.9 12 21.9C9.26641 21.9 6.79018 20.7909 4.99962 19.0003C3.20906 17.2098 2.09998 14.7335 2.09998 12C2.09998 9.26643 3.20906 6.79019 4.99962 4.99963C6.71066 3.28859 9.04794 2.19961 11.6385 2.10648ZM10.3375 4.07061C8.76825 4.39779 7.36567 5.17917 6.27241 6.27242C4.80561 7.73922 3.89997 9.76299 3.89997 12C3.89997 14.237 4.80561 16.2608 6.27241 17.7276C7.73921 19.1944 9.76297 20.1 12 20.1C14.237 20.1 16.2607 19.1944 17.7275 17.7276C18.8208 16.6343 19.6022 15.2317 19.9293 13.6625C19.3114 13.8177 18.6649 13.9 18 13.9C15.8187 13.9 13.8425 13.0148 12.4138 11.5861C10.9852 10.1575 10.1 8.18126 10.1 5.99999C10.1 5.33506 10.1823 4.6886 10.3375 4.07061ZM12.0483 4.65617C11.9512 5.08811 11.9 5.53776 11.9 5.99999C11.9 7.68471 12.5818 9.20847 13.6866 10.3133C14.7915 11.4182 16.3153 12.1 18 12.1C18.4622 12.1 18.9118 12.0487 19.3438 11.9517L12.0483 4.65617Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerOutline);
export default __webpack_public_path__ + "static/media/sticker_outline.2d56bb4de99ce56af93fc5a7a8b2a4bd.svg";
export { ForwardRef as ReactComponent };